// src/components/ServerDatabase/ServerGrid.jsx
import React from 'react';
import ServerCard from './ServerCard';
import { useLanguage } from '../../contexts/LanguageContext';

const ServerGrid = ({
  servers,
  onCopyIp,
  onOpenModal,
  onConnectRcon
}) => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  if (!servers || servers.length === 0) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '10px 0 36px 0', width: '100%' }}>
        <div
          style={{
            width: '100%',
            maxWidth: '390px',
            background: 'rgba(14, 14, 18, 0.75)',
            border: '1px solid rgba(255, 255, 255, 0.14)',
            borderRadius: 'var(--sdb-radius-xl)',
            padding: '18px 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            color: 'rgba(255, 255, 255, 0.55)',
            fontSize: '0.92rem',
            fontWeight: 500,
            backdropFilter: 'var(--sdb-blur-card)',
            WebkitBackdropFilter: 'var(--sdb-blur-card)',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)'
          }}
        >
          <svg
            viewBox="0 0 24 24"
            width="16"
            height="16"
            stroke="currentColor"
            fill="none"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <span>{isEn ? 'No servers found' : 'Серверов не найдено'}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="sdb-servers-grid">
      {servers.map((server) => (
        <ServerCard
          key={server.id || `${server.ip}:${server.port}`}
          server={server}
          onCopyIp={onCopyIp}
          onOpenModal={onOpenModal}
          onConnectRcon={onConnectRcon}
        />
      ))}
    </div>
  );
};

export default ServerGrid;
